import 'dayjs/locale/pt-br'

import dayjs from 'dayjs'
import { Calendar } from 'lucide-react'

interface PersonEvent {
  id: string
  event: Event | 'ANALYSIS_COMPLETED'
  personId: string
  createdAt: Date
}
interface EventStepItemProps {
  personId: string
  eventStep: PersonEvent
  eventLabel: string
  order: number
}

dayjs.locale('pt-br')

export const EventStepItem = ({ eventStep, eventLabel, order }: EventStepItemProps) => {
  return (
    <div className="flex gap-4">
      <div>
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-green-primary-5 text-xs font-bold text-brand-grayscale-1">
          {order}
        </div>
      </div>

      <div className="flex flex-col justify-center">
        <span className="text-sm font-bold text-brand-green-primary-5">{eventLabel}</span>
        <div className="mt-1 flex items-center gap-1">
          {eventStep.createdAt && (
            <>
              <Calendar size={14} />{' '}
              <span className="text-xs text-brand-grayscale-12">
                {dayjs(eventStep.createdAt).format('DD [de] MMMM [às] HH:mm')}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
